// src/helpers/reports/reportBucketToEndpointType.ts
function reportBucketToEndpointType(bucket) {
  switch (bucket) {
    case "customReports":
      return "custom";
    case "itemComboSalesReports":
      return "itemComboSales";
    case "salesOverviewReports":
      return "salesOverview";
    case "endOfShiftReports":
      return "endOfShift";
    case "creditCardBatchReports":
      return "creditCardBatch";
    case "employeeSalesAndTipsReports":
      return "employeeSalesAndTips";
    case "voidReasonsReports":
      return "voidReasons";
    case "inventoryOnHandReports":
      return "inventoryOnHand";
    case "creditBalancesReports":
      return "creditBalances";
  }
}

export { reportBucketToEndpointType };
